<template>
  <section class="vs-container container">
    <!-- {{ msg }} -->
    <div class="text-center">
      <h2 class="mb-15 sm:mb-40">
        Yes, It’s Different. <span class="inline-block">Yes, It Works.</span>
      </h2>
      <p class="heading">
        We understand that this is not the traditional way to buy a vehicle,
        but the traditional way is outdated and has some serious flaws.
      </p>
    </div>

    <div class="flex-chart">
      <AppCard
        v-for="(column, index) in columns"
        :key="index"
        flat
        class="chart-card"
        :class="column.cardStyles"
        :radius="column.roundedStyles"
      >
        <div
          class="chart-heading"
        >
          <h3 class="heading-text">
            {{ column.title }}
          </h3>
        </div>

        <ul
          class="px-20 md:px-40 lg:px-50 py-40 h-full"
          :class="column.listStyles"
        >
          <li
            v-for="(item, itemIndex) in column.listItems"
            :key="itemIndex"
            class="comparison-card__list-item flex flex-row items-start justify-start mb-25 md:mb-40 lg:mb-30"
          >
            <FontAwesomeIcon
              class="comparison-card__icon relative"
              :class="{
                'text-coral-400': column.color === 'coral',
                'text-blue-400': column.color === 'blue',
              }"
              icon="chevron-circle-right"
            />
            <div class="list-container">
              <h3 class="list-title">
                {{ item.title }}
              </h3>
              <p class="comparison-card__text">
                {{ item.text }}
              </p>
            </div>
          </li>
        </ul>
      </AppCard>
    </div>
  </section>
</template>

<script>
import AppCard from '@/components/common/cards/AppCard2'

export default {
  // Name
  name: 'TraditionalVsCd',

  // Components
  components: {
    AppCard
  },

  // Data
  data () {
    return {
      columns: [{
        title: 'Traditional Car Shopping',
        color: 'coral',
        roundedStyles: 'rounded-15 sm:rounded-r-none',
        cardStyles: 'sm:border-r-0',
        listStyles: 'border-gray-300 sm:border-r-1',
        listItems: [{
          title: 'Time Consuming',
          text: 'Spend hours or days looking at cars without knowing what type of financing you can get approved for.'
        }, {
          title: 'Inefficient',
          text: 'Trips to multiple dealerships, negotiating with salespeople, bank appointments, the entire process can result in a lot of unnecessary stress.'
        }, {
          title: 'Potential Rejection',
          text: 'There is nothing worse than spending all that time finding a vehicle you love just to discover you can’t actually get approved for a loan to buy it!'
        }]
      }, {
        title: 'Canada Drives',
        color: 'blue',
        roundedStyles: 'rounded-15 sm:rounded-l-none',
        cardStyles: 'sm:border-l-0',
        listItems: [{
          title: 'Fast & Easy',
          text: 'Complete our free online application in under 3 minutes from anywhere, at anytime.'
        }, {
          title: 'Stress-Free',
          text: 'Once you get pre-approved we will only show you vehicles you qualify for, so you won\'t waste time looking at cars outside your budget'
        }, {
          title: 'Any Credit Accepted',
          text: 'We believe that every Canadian should have access to the financing they need, regardless of their credit situation. No fear of rejection here!'
        }]
      }]
    }
  }
}
</script>

<style scoped lang="scss">

  .vs-container {
    line-height: 1.5;
    margin: 60px auto -20px !important;
    text-align: center;
    @include breakpoint('tablet-portrait-up') {
      padding: 0 20px;
    }
    @include breakpoint('tablet-landscape-up') {
      max-width: 1100px;
    }
    @include breakpoint('desktop-up') {
      margin-top: 120px !important;
    }
  }

  .heading {
    font-size: 16px;
    line-height: 25px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 60px;
    max-width: 530px;
    @include breakpoint('tablet-portrait-up') {
      font-size: 17px;
      line-height: 26px;
    }
    @include breakpoint('tablet-landscape-up') {
      margin-bottom: 80px;
    }
  }

  .flex-chart {
    display: flex;
    flex-direction: column;
    @include breakpoint('tablet-portrait-up') {
      flex-direction: row;
    }
  }

  .chart-card {
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #dedede;
    border-radius: 15px;
    margin-bottom: 50px;
    overflow: hidden;
    &:first-child {
      @include breakpoint('tablet-portrait-up') {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border-right-width: 0;
        width: 50%;
      }
      .chart-heading {
        background: transparent linear-gradient(83deg, #FF7D4D 0%, #FFC069 100%) 0% 0% no-repeat padding-box;
      }
      svg {
        color: #FF7D4D;
      }
      ul {
        @include breakpoint('tablet-portrait-up'){
          border-right-width: 1px;
          border-right-style: solid;
          border-right-color: #dedede;
        }
      }
    }
    &:last-child {
      @include breakpoint('tablet-portrait-up') {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-left-width: 0;
        width: 50%;
      }
      .chart-heading {
        background: linear-gradient(120deg, #07a3ee, #28e8ff);
      }
      svg {
        color: #07a3ee;
      }
    }
  }

  .chart-heading {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 70px;
  }

  .heading-text {
    font-family: sofia-pro,sans-serif;
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    text-align: center;
    color: #fff;
    @include breakpoint('tablet-portrait-up') {
      font-size: 24px;
      line-height: 32px;
    }
  }

  ul {
    list-style: none;
    margin-top: 0;
    height: 100%;
    padding: 40px 20px;
    @include breakpoint('tablet-landscape-up') {
      padding: 40px;
    }
    li {
      line-height: 1.5;
      list-style: none;
      display: flex;
      text-align: left;
      flex-direction: row;
      align-items: flex-start;
      justify-content: flex-start;
      margin-bottom: 25px;
      &:last-child{
        margin-bottom: 0;
      }
      @include breakpoint('tablet-landscape-up') {
        margin-bottom: 40px;
      }
    }
  }

  .list-container {
    padding-left: 10px;
    margin-top: -6px;
  }

  .list-title {
    margin: 0;
    margin-bottom: 15px;
    font-size: 20px;
    line-height: 30px;
    @include breakpoint('tablet-portrait-up') {
      font-size: 24px;
      line-height: 32px;
    }
  }

  .comparison-card {
    &__icon {
      font-size: 22px;
      top: 5px;
    }

    &__list-item:last-child {
      margin-bottom: 0;
    }

    &__text {
      font-size: 14px;
      line-height: 1.8;
    }
  }
</style>
